var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"fileInput",attrs:{"type":"file","name":"file","multiple":_vm.mode==='multiple'},on:{"change":function($event){_vm.onFileChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }